/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreacionArticuloModelDto } from '../../models/creacion-articulo-model-dto';

export interface InformacionAdicionalControllerActualizarArticulo$Params {

/**
 * UUID del artículo a actualizar
 */
  uuidArticulo: string;
  
    /**
     * Datos del artículo a actualizar
     */
    body?: CreacionArticuloModelDto
}

export function informacionAdicionalControllerActualizarArticulo(http: HttpClient, rootUrl: string, params: InformacionAdicionalControllerActualizarArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, informacionAdicionalControllerActualizarArticulo.PATH, 'post');
  if (params) {
    rb.path('uuidArticulo', params.uuidArticulo, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

informacionAdicionalControllerActualizarArticulo.PATH = '/api/informacion-adicional/actualizar-articulo/{uuidArticulo}';
